

import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Typography } from '@mui/material'
import moment from 'moment'
import { saveAs } from 'file-saver'

// COMPONENT
import * as styled from '../style/main.style'
import Header from '../Header'
import Navbar from '../Navbar'
import TableRowCommon from '../../../component/table/TableRowCommon'
import TableCustom from '../../../component/table/tableCustom'
import { RequestLogApi, getLogTypeProps } from '../../../api/request-log/requestLog.api'
// API
import { FiscalYearApi } from '../../../api/fiscal-year/fiscalyear.api'
import { ProjectApi } from '../../../api/project/project.api'
import { useDispatch, useSelector } from 'react-redux'
import { setLoading, unsetLoading } from '../../../store/slice/loading/loading.slice'
import Loading from '../../../component/loading/Loading'
import MenuDropdown from '../../../component/menu-dropdown/MenuDropdown'
import InputNewRangePicker from '../../../component/input/inputRankPicker'



const UsageStatistics: React.FC = () => {
    // moment.locale('th');
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isLoading = useSelector((state: any) => state?.loading?.isLoading);
    // const permission = useSelector((state: any) => state?.permission?.permission);

    // const navigate: NavigateFunction = useNavigate();

    const [isFocused, setIsFocused] = useState<boolean>(false);
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(5);
    const [totalPage, setTotalPage] = useState<number>(Number);
    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");
    const [selectedDateRange, setSelectedDateRange] = useState<string[]>([]);

    const [fiscalYear, setFiscalYear] = useState<any[]>([]);
    const [requestLog, setRequestLog] = useState<any[]>([]);
    const [projectStatus, setProjectStatus] = useState<any[]>([]);
    const [idFiscalYear, setIdFiscalYear] = useState<number>(Number);
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC")

    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }
    // API
    const handleGetFiscalYear = async () => {
        let condition: any = {}
        await FiscalYearApi.getFiscalYear(condition)
            .then(res => {
                if (res.status === 200) {
                    setFiscalYear(res.data?.result?.items)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }
    const handleGetProjectStatus = async () => {
        let condition: any = {}
        await ProjectApi.getProjectStatus(condition)
            .then(res => {
                if (res.status === 200) {
                    setProjectStatus(res.data?.result)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }
    const handleGetLog = useCallback(async () => {
        let condition: getLogTypeProps = {
            page: page,
            limit: pageLimit
        }
        if (!startDate && !endDate) {
            dispatch(setLoading())
        }
        if (endDate) condition = { ...condition, endDate: endDate }
        if (startDate) condition = { ...condition, startDate: startDate }
        if (idFiscalYear) condition = { ...condition, idFiscalYear: idFiscalYear }
        if (sortBy) condition = { ...condition, sortBy: sortBy }
        if (sortType) condition = { ...condition, sortType: sortType }


        await RequestLogApi.GetLog(condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    setRequestLog(res.data?.result?.items)
                    setTotalPage(res.data?.result?.meta?.totalItems)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }, [page, pageLimit, endDate, startDate, idFiscalYear, sortBy, sortType])

    const handleDownloadLog = useCallback(async (format: 'pdf' | 'excel') => {
        dispatch(setLoading())
        let condition: getLogTypeProps = {
            format: format,
            page: page,
            limit: pageLimit
        }
        if (endDate) condition = { ...condition, endDate: endDate }
        if (startDate) condition = { ...condition, startDate: startDate }
        if (idFiscalYear) condition = { ...condition, idFiscalYear: idFiscalYear }
        if (sortBy) condition = { ...condition, sortBy: sortBy }
        if (sortType) condition = { ...condition, sortType: sortType }
        await RequestLogApi.download(condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    const data = res?.data
                    if (format === 'pdf') {
                        const blob = new Blob([data], { type: 'application/pdf' });
                        saveAs(blob, 'log-pdf-e-monitering');
                    } else if (format === 'excel') {
                        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        saveAs(blob, 'log-xlsx-e-monitering');
                    }
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
            .finally(() => dispatch(unsetLoading()))
    }, [page, pageLimit, endDate, startDate, idFiscalYear, sortBy, sortType])



    const headCells = [
        {
            id: "idRequestLog", width: 90, sortable: true, disablePadding: false, align: 'center', label: "ลำดับ"
        },
        {
            id: "createDate", disablePadding: false, width: 195, sortable: true, align: "center", label: "วันที่"
        },
        {
            id: "ip", disablePadding: false, align: "center", width: 141, label: "IP Address"
        },
        {
            id: "url", disablePadding: false, align: "center", width: 257, label: "กิจกรรมที่ใช้งาน"
        },
        {
            id: "employeeName", disablePadding: false, align: "center", width: 210, label: "ผู้ใช้งาน"
        },
        {
            id: "method", disablePadding: false, align: "center", width: 140, label: "วิธีการ"
        },
        {
            id: "platform", disablePadding: false, align: "center", width: 140, label: "จุดบริการ"
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const { idRequestLog, ip, createDate, employeeName, url, method, platform } =
            objData;

        const objRenderData = {
            key: idRequestLog,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: idRequestLog || "-" },
                {
                    option: "TEXT",
                    align: "center",
                    label: moment(createDate).add(543, 'year').format("DD/MM/YYYY HH:ss น.") || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: ip || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    disablePadding: true,
                    label: url || "-"
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: employeeName || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: method || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: platform || "-",
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    const handleRangeDate = (value: any) => {
        setSelectedDateRange(value);
        setStartDate(moment(value[0]).format("YYYY-MM-DD"));
        setEndDate(moment(value[1]).format("YYYY-MM-DD"));
    };
    const handleClearRangeDate = () => {
        setSelectedDateRange([]);
        setStartDate("");
        setEndDate("");
    };

    useEffect(() => {
        handleGetLog();
    }, [handleGetLog])
    useEffect(() => {
        handleGetFiscalYear();
        handleGetProjectStatus()
    }, [])

    return (
        <styled.ContainerHome>
            {isLoading === true && <Loading />}
            <Navbar />
            <styled.MainContainer>
                <Header />
                <styled.Content>
                    <section className='w-full gap-3 flex items-start md:items-center flex-col  md:flex-row justify-between'>
                        <span>
                            <Typography className='text-primary' variant='h4'>
                                {t("สถิติการใช้งาน")}
                            </Typography>
                        </span>
                    </section>
                    <section className='w-full mt-8'>
                        <article className='grid grid-cols-12 gap-x-1 gap-y-2'>
                            <span className='col-span-12 md:col-span-3 lg:col-span-3 self-end'>
                                <InputNewRangePicker
                                    value={selectedDateRange}
                                    onchange={handleRangeDate}
                                    onClear={handleClearRangeDate}
                                    allowClear
                                    label={"ระบุวันที่"}
                                    heading='จากวันที่ - ถึงวันที่'
                                />
                            </span>
                            <span className='col-span-12 ld:col-span-7 lg:col-span-7'></span>
                            <span className='col-span-12 lg:col-span-2 flex justify-end gap-1 overflow-hidden'>
                                <span className='w-auto flex flex-col self-end gap-2'>
                                    <MenuDropdown
                                        headingNormal
                                        heading='ส่งออกเอกสาร'
                                        buttonName='ดาวน์โหลด'
                                        menuItems={[
                                            { id: 1, name: "pdf", onClick: () => handleDownloadLog('pdf') },
                                            { id: 2, name: 'excel', onClick: () => handleDownloadLog('excel') }
                                        ]}
                                    />
                                </span>
                            </span>
                        </article>
                    </section>

                    <section className='w-full mt-3' >
                        {requestLog && (
                            <TableCustom
                                tableFixedWidth
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy={sortBy}
                                sortType={sortType}
                                headCells={headCells}
                                rowCount={totalPage}
                                rowsData={requestLog && requestLog.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={handleRequestSort}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                            />
                        )}
                    </section>
                </styled.Content>
            </styled.MainContainer>

        </styled.ContainerHome>
    )
}

export default UsageStatistics
